export default function () {
  return {
    all: [],
    allocations: [],
    transactions: [],
    transferCards: null,
  };
}
